import { useQuery } from '@apollo/client';
import type { UseGetDefaultParentOrganizationId } from '@openx/components-organization/lib/utils/context/OrganizationHookTypes';
import { GetDefaultParentOrganizationIdDocument } from '../../../graphql/query/organizations/GetDefaultParentOrganizationId.generated';

export const useGetDefaultParentOrganizationId: UseGetDefaultParentOrganizationId = () => {
  const { data, error, loading } = useQuery(GetDefaultParentOrganizationIdDocument);

  return {
    accountId: data?.account?.[0]?.id,
    error,
    loading,
  };
};
